import { motion } from "framer-motion";
import { Button } from "../ui/button";
import { Shield, CheckCircle } from "lucide-react";
import analytics from "../../../../libs/analytics";

const Guarantee = () => {
  const scrollToSection = (e: React.MouseEvent, sectionId: string) => {
    e.preventDefault();
    e.stopPropagation();
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="py-20 md:py-32 bg-card relative overflow-hidden">
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-px bg-gradient-to-r from-transparent via-primary/30 to-transparent" />
      </div>

      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="max-w-4xl mx-auto"
        >
          <div className="card-glass rounded-3xl p-8 md:p-12 border-primary/30 relative overflow-hidden">
            {/* Background Glow */}
            <div className="absolute inset-0 bg-gradient-to-br from-primary/5 via-transparent to-accent/5 pointer-events-none" />
            
            <div className="relative z-10 flex flex-col md:flex-row items-center gap-8 md:gap-12">
              {/* Shield Icon - Destaque com branco e roxo */}
              <motion.div
                animate={{ rotate: [0, 5, -5, 0] }}
                transition={{ duration: 4, repeat: Infinity, ease: "easeInOut" }}
                className="flex-shrink-0"
              >
                <div className="w-32 h-32 md:w-40 md:h-40 rounded-full bg-white flex items-center justify-center shadow-[0_0_60px_hsl(277_78%_40%/0.4)]">
                  <div className="w-24 h-24 md:w-32 md:h-32 rounded-full bg-gradient-to-br from-primary/30 to-primary/50 flex items-center justify-center">
                    <Shield className="w-12 h-12 md:w-16 md:h-16 text-primary" />
                  </div>
                </div>
              </motion.div>

              {/* Content */}
              <div className="text-center md:text-left">
                <h2 className="font-display text-3xl md:text-4xl font-bold mb-4">
                  Risco zero.{" "}
                  <span className="text-gradient">Confiança total.</span>
                </h2>
                
                <p className="text-lg text-muted-foreground mb-6 leading-relaxed">
                  Teste o Ataric por <strong className="text-foreground">7 dias</strong>. 
                  Se você não sentir que está falando inglês com mais confiança, 
                  <strong className="text-foreground"> cancelamos e devolvemos seu dinheiro</strong>. 
                  Sem perguntas. Sem burocracia. Sem letras miúdas.
                </p>

                <div className="flex flex-wrap items-center justify-center md:justify-start gap-4 mb-8">
                  <div className="flex items-center gap-2 text-sm text-muted-foreground">
                    <CheckCircle className="w-4 h-4 text-primary" />
                    7 dias de teste
                  </div>
                  <div className="flex items-center gap-2 text-sm text-muted-foreground">
                    <CheckCircle className="w-4 h-4 text-primary" />
                    Reembolso garantido
                  </div>
                  <div className="flex items-center gap-2 text-sm text-muted-foreground">
                    <CheckCircle className="w-4 h-4 text-primary" />
                    Cancele quando quiser
                  </div>
                </div>

                <Button type="button" variant="cta" size="xl" onClick={(e) => { analytics.landingCtaClicked('guarantee'); scrollToSection(e, 'planos'); }}>
                  👉 Começar a falar com o Ataric
                </Button>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Guarantee;
